import SharedPreferences from "../../core/utils/SharedPreferences";
import { AxiosBuilder } from "../../data/api/AxiosBuilder";
import { BASE_URL } from "../../data/constant/ApiConstants";
import {
  ENCRYPTION_SECRET_KEY,
  STORAGE_KEYS,
} from "../../data/constant/Constants";
import { AesGcmEncryptionService } from "../../data/service/encryptionService";

export function provideApiBuilder() {
  const encryptionProvider = () =>
    AesGcmEncryptionService.fromBase64Key(ENCRYPTION_SECRET_KEY);
  return new AxiosBuilder()
    .baseUrl(BASE_URL!)
    .timeout(4 * 60 * 1000)
    .headers({
      Authorization: `Bearer ${SharedPreferences.getString(
        STORAGE_KEYS.TOKEN
      )}`,
    })
    .responseType("json")
    .addEncryption(encryptionProvider)
    .build();
}
